import CollapseManager from "../../js/components/collapseManager";
export default class TextCollapse extends HTMLElement {
    constructor() {
        super();
        this.translations = JSON.parse(this.getAttribute('translations'));
        this.infoExtraText = JSON.parse(this.getAttribute('text'));
        this.stylesheet = this.getAttribute('stylesheet');
    }
    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#text-collapse');
        this.instance = t.content.cloneNode(true);
        let titleContainer = this.instance.querySelector('[name="text-title"]');
        this.instance.querySelector('[name="title-collapse"]').innerHTML = this.translations.title;
        this.instance.querySelector('[name="description"]').innerHTML = this.infoExtraText;
        this.instance.querySelector('[name="text-description-readmore-button"]').innerHTML = this.translations.seeMore;
        this.instance.querySelector('[name="text-description-readless-button"]').innerHTML = this.translations.seeLess;
        let collapseDiv = this.instance.querySelector('[name="text-description-collapse-button"]');
        this.instance.querySelector('[name="text-description-readless-button"]').addEventListener("click",  (event) => {
            let topDistance = window.pageYOffset + titleContainer.getBoundingClientRect().top;
            if (document.querySelector('.sticky-element')) {
                topDistance -= document.querySelector('.sticky-element').offsetHeight;
            }
            window.scrollTo({
                top: topDistance,
                behavior: 'instant',
            });
            event.stopPropagation();
            collapseDiv.click();
        });
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this._shadowRoot.appendChild(this.instance);
        new CollapseManager( this._shadowRoot);
    }
}